import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { ReportStatusQuery, ReportStatusQueryVariables } from '@/shared/api';
import REPORT_STATUS_QUERY from '../queries/reportStatus';

/**
 * Loads the current status of a report. Runs the report status query for the id and throws the first GraphQL error only when no report came back.
 *
 * @param id - Identifier of the report to inspect.
 * @returns A promise resolving to the report carrying its status.
 */
const fetchReportStatus = async (id: any) => {
  const client = createClient();
  const result = await client.query<ReportStatusQuery, ReportStatusQueryVariables>({
    query: REPORT_STATUS_QUERY,
    variables: {
      id,
    },
  });
  const { data, errors } = result;
  const { report } = data;
  if (_.isNil(report) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return report;
};

export default fetchReportStatus;
